"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TicketsHolder = (function () {
    function TicketsHolder() {
    }
    TicketsHolder.prototype.clearTickets = function () {
    };
    TicketsHolder.prototype.showTickets = function (response, _matches) {
        var html = '';
        for (var key in response) {
            html += this.prepareHTML(response[key], key);
        }
        $('#ticketsScroll').html(html);
    };
    TicketsHolder.prototype.factorial = function (n) {
        return (n < 2) ? 1 : this.factorial(n - 1) * n;
    };
    TicketsHolder.prototype.prepareHTML = function (ticket, ticketId) {
        var translation = window['langArr'][window['language']];
        var html = '<div class="ticket-holder ticket-holder-virtualf">\
            <div class="ticket-bar ticket-bar clearfix">\
                <div class="ticket-bar-left">' + translation['ticket_id'] + ' : ' + ticketId + '</div>\
                <div class="ticket-bar-right">' + translation['open'] + '</div>\
            </div>\
            <div class="ticket-body-virtualf">';
        var maxWin = 0;
        var amount = 0;
        var systemFrom = 1;
        var systemTo = 1;
        for (var key in ticket) {
            var winningTicket = (ticket[key]['itemStatus'] == 3) ? 'style="color: #36ba14;"' : "";
            if (ticket[key]['maxWin'] <= window['footballMaxWin']) {
                maxWin = ticket[key]['maxWin'];
            }
            else {
                maxWin = window['footballMaxWin'];
            }
            amount = ticket[key]['amount'];
            html += '<div class="ticket-virtual-bar" ' + winningTicket + '>\
                    <div class="virtualf-team-holder">\
                        <div class="team-home">' + ticket[key]['home'] + '</div>-<div class="team-away">' + ticket[key]['away'] + '</div>\
                    </div>\
                    <div class="virtualf-result-holder">\
                        ' + ticket[key]['oddName'] + '\
                    </div>\
                    <div class="virtualf-odds-holder">\
                        ' + ticket[key]['oddValue'] + '\
                    </div>\
                </div>';
            systemFrom = ticket[key]['systemFrom'];
            systemTo = ticket[key]['systemTo'];
        }
        var combinations = this.factorial(ticket.length) / (this.factorial(systemFrom) * this.factorial(ticket.length - systemFrom));
        html += '<div class="virtualf-tickets-stats-holder">\
                    <div class="virtualf-tickets-stats">\
                        <div>' + translation['combinations'] + ': <span>' + Math.round(combinations * 1000) / 1000 + '</span></div>\
                        <div>' + translation['system'] + ': <span>' + systemFrom + '/' + systemTo + '</span></div>\
                        <div>' + translation['total_stake'] + ': <span>' + amount.toFixed(2) + '</span></div>\
                    </div>\
                    <div class="virtualf-potential-max-win">\
                        <div class="vpmw-title">' + translation['potential_maximal_win'] + '</div>\
                        <div class="vpmw-amount vpmw-amount-won">' + maxWin.toFixed(2) + ' ' + window['currency'] + ' </div>\
                    </div>\
                </div>\
            </div>\
        </div>';
        return html;
    };
    return TicketsHolder;
}());
exports.default = TicketsHolder;



//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football/ts/tickets/tickets-holder.ts
// module id = 1992
// module chunks = 6